import { render, staticRenderFns } from "./VendorMenu.vue?vue&type=template&id=6dbc0034&scoped=true&"
import script from "./VendorMenu.vue?vue&type=script&lang=js&"
export * from "./VendorMenu.vue?vue&type=script&lang=js&"
import style0 from "./VendorMenu.vue?vue&type=style&index=0&id=6dbc0034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbc0034",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
